import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { onceEach } from "~/jose_modern/once.js";

function initReceiveButton(container) {
  const btns = container.querySelectorAll("[data-receive-button]");
  if (!btns.length) return;

  onceEach(btns, "receive-button", (btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent("purchase-order:receive"));
    });
  });
}

onViewLoad("purchase_orders#edit_receive", () => {
  initReceiveButton(document);
});
